import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { forViewer, joinRequestsQuery, viewerIdOf } from "../services/queries";

export const useJoinRequests = (options?: { enabled?: boolean }) => {
  const { user, token } = useAuth();
  const orgId = user?.schoolId || user?.orgId;

  return useQuery({
    ...forViewer(joinRequestsQuery(orgId, token), viewerIdOf(user)),
    enabled: (options?.enabled ?? true) && !!orgId && !!token,
  });
};
